import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { QRCodeSVG } from 'qrcode.react';
import ReactDOMServer from 'react-dom/server';
import "@fontsource/roboto";
// import "@fontsource/tahoma";
import { getAssinaturaResponsavel } from "../../../services/director.service";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
/** REINDERIZAÇÃO DE IMAGEM, PARA CONVERÇÃO **/
function getBase64Image(img) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
function capitalizeWords(str) {
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}


// FUNÇÃO PARA GERAR PDF DE AUTORIZAÇÃO DE EXERCÍCIO DE FÁBRICAS
const AutorizacaoFabricas = async (dado) => {
    const assinatura = dado?.por?.dadosPessoais?.nome === 'Pombal Ngonga Mayembe' ? { nome: 'Dr. Pombal Mayembe' } : await getAssinaturaResponsavel('Director Geral');

    const baseUrl = 'https://www.armed.gov.ao';
    const url = `${baseUrl}/verifica-estabelecimento/${dado.estabelecimento._id}`;
    const qrpic = await fetch('/img/faviconARMED.png').then(res => res.blob());
    const qrpic64 = await getBase64Image(qrpic);
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG value={url} renderAs="svg" imageSettings={{ src: `${qrpic64}`, height: 20, width: 20, excavate: true }} />
    );

    const imageBlob = await fetch('/img/logo/InsigniaAngola.png').then(res => res.blob());
    const imageBase64 = await getBase64Image(imageBlob);
    const imageFundo = await fetch('/img/backGrounds/modeloFabrica2.png').then(res => res.blob());
    const imageFundo64 = await getBase64Image(imageFundo);
    // const logoArmedBlob = await fetch('/img/logo/logoArmed.png').then(res => res.blob());
    // const logoArmed64 = await getBase64Image(logoArmedBlob);
    // const logoGovMinsaBlob = await fetch('/img/logo/logoGovMinsa.png').then(res => res.blob());
    // const logoGovMinsa64 = await getBase64Image(logoGovMinsaBlob);

    pdfMake.fonts = {
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        },
    };

    // Tahoma
    // pdfMake.fonts.Tahoma = {
    //     normal: 'Tahoma-Regular.ttf',
    //     bold: 'Tahoma-Bold.ttf',
    //     italics: 'Tahoma-Italic.ttf',
    //     bolditalics: 'Tahoma-BoldItalic.ttf'
    // };

    const fmtDate = (d) => new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const dataEmissao = new Date(dado.dataEmissao);
    const dataExpiracao = new Date(dado.dataExpiracao);
    const anosDeValidade = dataExpiracao.getFullYear() - dataEmissao.getFullYear();

    // linhas de produção e âmbito vêm como arrays no dado ([] se não existirem)
    const linhas = dado?.linhasProducao ?? [];
    const escopo = dado?.escopoProducao ?? [];
    //   const chk = (val, arr) => arr.includes(val) ? '» ☑' : '» ☐';
    const chk = (val, arr) => arr.includes(val) ? '» [X]' : '» [  ]';

    const sectionTitle = (txt) => ({
        text: txt,
        bold: true,
        fontSize: 10,
        // decoration: 'underline',
        margin: [45, 8, 45, 3],
    });

    const infoRow = (label, value) => ({
        columns: [
            { text: `» ${label}`, width: 160, fontSize: 10 },
            { text: ':', width: 8, fontSize: 10 },
            { text: value ?? '', fontSize: 10, width: '*', bold: true },
        ],
        margin: [60, 1, 45, 1],
    });


    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [15, 30, 15, 90],
        content: [
            // ---- Cabeçalho: QR + tipo ----
            {
                columns: [

                    // {
                    //     width: '50%',
                    //     stack: [{ text: `${dado?.estabelecimento?.tipo?.designacao}`.toUpperCase() }],
                    //     alignment: 'right', style: 'header',
                    // },
                    {
                        width: '100%',
                        stack: [{ svg: qrCodeSVG, width: 40, height: 40 }],
                        alignment: 'right',
                    },
                ],
                margin: [20, 0, 20, 0],
            },
            // ---- Insignia ----
            { image: imageBase64, width: 55, height: 55, alignment: 'center', margin: [0, -35, 0, 0] },
            // // ---- Títulos institucionais ----
            // { text: 'REPÚBLICA DE ANGOLA', style: 'header' },
            // { text: 'Ministério da Saúde', style: 'subheader' },
            // { text: 'Agência Reguladora de Medicamentos e Tecnologias de Saúde', style: 'subheader' },
            // // ---- Título do documento ----
            [
                { text: "REPÚBLICA DE ANGOLA", style: "header" },

                {
                    canvas: [
                        {
                            type: "line",
                            x1: 242.25,
                            y1: 0,
                            x2: 322.75,
                            y2: 0,
                            lineWidth: 1.8,
                            lineColor: "#FFBA00"
                        }
                    ],
                    margin: [0, 3, 0, 5]
                },

                { text: "Ministério da Saúde", style: "subheader" },
            ],

            {
                text: "Agência Reguladora de Medicamentos e Tecnologias de Saúde",
                style: "subheader2",
            },


            { text: 'AUTORIZAÇÃO DE EXERCÍCIO DA ACTIVIDADE FABRIL', style: 'declaration', margin: [0, 20, 0, 2] },
            { text: `N.º ${dado?.estabelecimento?.numeroAutorizacao ?? '00'}/ARMED/${dataEmissao.getFullYear()}`, style: 'declaration', margin: [0, 0, 0, 20] },
            // ---- Texto legal ----
            {
                text:
                    'Tendo sido cumpridos os requisitos consignados no artigo 00.º do ' +
                    'Regulamento sobre o licenciamento de unidades de produção de produtos farmacêuticos' +
                    ', aprovado através do Decreto Presidencial n.º XXX/26 de Xxxxxxxxx, ', margin: [45, 0, 45, 6], style: 'body',
            },

            { text: 'No uso das competências conferidas pelo artigo n.º 4 do Decreto Presidencial n.º 136/21, de 1 de Junho, que aprova o Estatuto Orgânico da Agência Reguladora de Medicamentos e Tecnologias de Saúde; ', margin: [45, 0, 45, 6], style: 'body', },

            {
                text: 'É concedida a presente Autorização de Exercício da Actividade Fabril de produtos Farmacêuticos à entidade abaixo identificada:',
                // bold: true,
                style: 'body',
                margin: [45, 0, 45, 6],
            },
            // ---- IDENTIFICAÇÃO ----
            sectionTitle('IDENTIFICAÇÃO:'),
            infoRow('Entidade', `${dado?.estabelecimento?.empresa?.nome ?? ''}`.toUpperCase()),
            infoRow('Número de Identificação Fiscal', dado?.estabelecimento?.empresa?.nif),
            infoRow('Representante', capitalizeWords(`${dado?.estabelecimento?.empresa?.representante?.dadosPessoais?.nome ?? ''}`)),
            infoRow('Endereço da Sede',
                `Província ${dado?.estabelecimento?.empresa?.provincia ?? ''}, Município de ${dado?.estabelecimento?.empresa?.municipio ?? ''}, Bairro ${dado?.estabelecimento?.empresa?.bairro ?? ''}, Rua ${dado?.estabelecimento?.empresa?.rua ?? ''}`
            ),
            infoRow('Endereço das Instalações',
                `Província ${dado?.estabelecimento?.provincia ?? ''}, Município de ${dado?.estabelecimento?.municipio ?? ''}, Bairro ${dado?.estabelecimento?.bairro ?? ''}, Rua ${dado?.estabelecimento?.rua ?? ''}`
            ),
            // ---- DIRECÇÃO TÉCNICA ----
            sectionTitle('DIRECÇÃO TÉCNICA'),
            infoRow('Director(a) Técnico(a)', capitalizeWords(`${dado?.estabelecimento?.directorTecnico?.dadosPessoais?.nome ?? ''}`)),
            infoRow('N.º da Associação Pública Profissional', dado?.estabelecimento?.directorTecnico?.numeroCarteira),
            // ---- ÂMBITO DA AUTORIZAÇÃO ----
            sectionTitle('ÂMBITO DA AUTORIZAÇÃO'),
            {
                text: 'A entidade está autorizada a produzir com a(s) seguinte(s) linha(s):',
                style: 'body', margin: [45, 2, 45, 2], fontSize: 10,
            },
            {
                columns: [
                    {
                        width: '50%',
                        stack: [
                            { text: `${chk('Produtos orais sólidos', linhas)}  Produtos orais sólidos`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Produtos injectáveis', linhas)}  Produtos injectáveis`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Produtos orais líquidos', linhas)}  Produtos orais líquidos`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Produtos semissólidos', linhas)}  Produtos semissólidos`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Produtos cosméticos', linhas)}  Produtos cosméticos`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Material Gastável', linhas)}  Material Gastável`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Gases medicinais', linhas)}  Gases medicinais`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Outros', linhas)}  Outros`, fontSize: 10 },
                        ],
                    },
                ],
                margin: [55, 2, 45, 4],
            },
            {
                text: 'A produção limita-se à:',
                style: 'body', margin: [45, 2, 45, 2], fontSize: 10,
            },
            {
                columns: [
                    {
                        width: '50%',
                        stack: [
                            { text: `${chk('Acondicionamento primário', escopo)}  Acondicionamento primário`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Acondicionamento secundário', escopo)}  Acondicionamento secundário`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Rotulagem', escopo)}  Rotulagem`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Reembalagem', escopo)}  Reembalagem`, fontSize: 10, marginBottom: 5 },
                            { text: `${chk('Libertação de lotes', escopo)}  Libertação de lotes`, fontSize: 10, marginBottom: 5 },
                        ],
                    },
                ],
                margin: [55, 2, 45, 4],
            },
            // ---- ESPECIFICAÇÃO ----
            sectionTitle('ESPECIFICAÇÃO DOS PRODUTOS FARMACÊUTICOS AUTORIZADOS'),
            {
                text: 'O exercício da actividade fabril fica limitado aos produtos farmacêuticos constantes do Anexo I da presente Autorização, nas condições e limites nele estabelecidos.',
                style: 'body', margin: [45, 2, 45, 6], fontSize: 10,
            },
            // ---- OBSERVAÇÕES ----
            sectionTitle('OBSERVAÇÕES:'),
            {
                stack: [
                    'A actividade fabril deve ser exercida em estrita observância da legislação farmacêutica nacional e das Boas Práticas de Fabrico (BPF).',
                    'A entidade deve manter permanentemente as condições técnicas, sanitárias, organizacionais e de recursos humanos que fundamentaram a emissão da presente Autorização.',
                    'Qualquer alteração relativa às instalações, equipamentos críticos, processos produtivos, categorias de produtos, Director Técnico ou demais responsáveis técnicos depende de comunicação prévia e, quando aplicável, de autorização da ARMED.',
                    'A presente autorização não substitui a Autorização de Introdução no Mercado (AIM) dos medicamentos, sempre que esta seja legalmente exigida.',
                    'A ARMED pode realizar inspecções ordinárias e extraordinárias para verificar a manutenção das condições de licenciamento.',
                    'O incumprimento da legislação aplicável pode determinar a suspensão, revogação ou cancelamento da presente Autorização, sem prejuízo das demais sanções legalmente previstas.',
                ].map((txt, i) => ({
                    columns: [
                        { text: `(${i + 1})`, width: 22, fontSize: 10, italics: true },
                        { text: txt, fontSize: 10, width: '*', italics: true },
                    ],
                    margin: [0, 0, 0, 4],
                    lineHeight: 1.3,
                })),
                margin: [55, 2, 45, 4],
            },
            dado?.restricaoAutorizacao ? {
                text: [{ text: 'Restrições: ', bold: true }, dado.restricaoAutorizacao],
                style: 'body', margin: [45, 4, 45, 2], fontSize: 10,
            } : {},
            // ---- EMISSÃO / VALIDADE ----
            {
                text: `EMISSÃO: ${fmtDate(dado.dataEmissao)}`, bold: true, fontSize: 10, width: '*',
                style: 'body', margin: [45, 20, 45, 5], fontSize: 10,
            },
            {
                text: `VALIDADE: ${fmtDate(dado.dataExpiracao)}  (${anosDeValidade} anos)`, bold: true, fontSize: 10, width: '*',
                style: 'body', margin: [45, 0, 45, 6], fontSize: 10,
            },
        ],
        header: function (currentPage, pageCount, pageSize) {
            return {
                columns: [
                    { width: '50%', stack: [{ svg: qrCodeSVG, width: 40, height: 40 }], alignment: 'left' },
                    { width: '50%', stack: [{ text: `${dado?.estabelecimento?.tipo?.designacao}`.toUpperCase() }], alignment: 'right', style: 'header' },
                ],
                margin: [50, 50, 175, 0],
            };
        },
        footer: function (currentPage, pageCount) {
            return {
                stack: [
                    {
                        stack: currentPage === pageCount ? [
                            { text: 'O Director Geral', alignment: 'center', style: 'signature' },
                            { text: '_____________________________', alignment: 'center', style: 'signature', margin: [0, 8, 0, 0] },
                            { text: assinatura?.nome ? capitalizeWords(assinatura.nome) : '', alignment: 'center', style: 'signature' },
                        ] : [],
                    },
                    // // Linha separadora
                    // { canvas: [{ type: 'line', x1: 30, y1: 0, x2: 565, y2: 0, lineWidth: 0.5, lineColor: '#888' }], margin: [0, 4, 0, 4] },
                    // // Logos + texto de contacto
                    // {
                    //     columns: [
                    //         { image: logoArmed64, width: 70, height: 22, alignment: 'left', margin: [30, 0, 0, 0] },
                    //         {
                    //             stack: [
                    //                 { text: 'Rua Che-Guevara nº 86/86A, Bº Maculusso, Ingombotas, Luanda – Angola', alignment: 'center', fontSize: 7 },
                    //                 { text: '+244 945 817 227  |  expediente@armed.gov.ao  |  www.armed.gov.ao', alignment: 'center', fontSize: 7 },
                    //                 { text: 'ARMED-SGQ-MOD-AUT.FAB.075.1.0', alignment: 'center', fontSize: 6, color: '#666', margin: [0, 1, 0, 0] },
                    //             ],
                    //             width: '*', margin: [0, 2, 0, 0],
                    //         },
                    //         { image: logoGovMinsa64, width: 80, height: 22, alignment: 'right', margin: [0, 0, 30, 0] },
                    //     ],
                    // },
                    {
                        text: [
                            dado?.observacao?.length ? 'Actualizado ' : '',
                            {
                                text: (() => {
                                    if (!dado?.observacao?.length) return '';
                                    const observacoesUnicas = [...new Map(dado.observacao.slice(-6).map((obs) => [obs.content, obs])).values()];
                                    const titulosAdicionados = new Set();
                                    return observacoesUnicas.slice(-6).map((obs) => {
                                        const dataActualizacao = new Date(obs?.date || obs?.createdAt).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
                                        const content = obs?.content || '';
                                        const palavra3 = content.split(' ')[2] || '';
                                        const titulo = palavra3 === 'director' ? 'Director Técnico' : palavra3.charAt(0).toUpperCase() + palavra3.slice(1);
                                        if (titulosAdicionados.has(titulo)) return null;
                                        titulosAdicionados.add(titulo);
                                        return `(${titulo}): ${dataActualizacao}`;
                                    }).filter(Boolean).join(', ');
                                })(),
                            }
                        ],
                        alignment: 'left', fontSize: 8, margin: [44, 15, 40, 0],
                    },
                ],
                margin: [0, -90, 0, 0],
            };
        },
        background: function (currentPage, pageSize) {
            return { image: imageFundo64, width: pageSize.width - 30, height: pageSize.height - 20, alignment: 'center', margin: [0, 10, 0, 10] };
        },
        styles: {
            header: { fontSize: 8, bold: false, alignment: 'center', margin: [0, 0, 0, 0] },
            subheader: { fontSize: 8, bold: true, alignment: 'center', margin: [0, 0, 0, 0] },
            subheader2: {
                fontSize: 8,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 0],
                color: "#919191",
            },

            declaration: { fontSize: 12, bold: true, alignment: 'center', margin: [0, 5, 0, 5] },
            body: { fontSize: 11, alignment: 'justify', margin: [0, 0, 0, 3], lineHeight: 1.3 },
            signature: { fontSize: 10, bold: true, margin: [0, 0, 0, 0] },
        },
        defaultStyle: { font: 'Roboto' },
    };

    return pdfMake.createPdf(docDefinition);
};

export {
    AutorizacaoFabricas
}
